import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import axios from "axios";
const columns = [
    {
        name: 'עיר',
        selector: row => row.ty,
        sortable: true,
    }, {
        name: 'שם מוסד',
        selector: row => row.MosName,
        sortable: true,
    }, {
        name: 'סוג',
        selector: row => row.Mtype,
        sortable: true,
    }, {
        name: 'מין',
        selector: row => row.Gender,
        sortable: true,
    }, {
        name: 'סמל',
        selector: row => row.Semel,
        sortable: true,
    }, {
        name: 'מנהל',
        selector: row => row.Principal,
        cell: (row) => (
            <EditableCell
                value={row.Principal}
                rowId={row.id || row.Semel}
                field="Principal"
                onUpdate={(newValue) => row.onUpdatePrincipal && row.onUpdatePrincipal(newValue, row)}
            />
        ),
        sortable: true,
    }, {
        name: 'טל מנהל',
        cell: (row) => (
            <EditableCell
                value={row.Ptel}
                rowId={row.id || row.Semel}
                field="Ptel"
                onUpdate={(newValue) => row.onUpdatePtel && row.onUpdatePtel(newValue, row)}
            />
        ),
        sortable: true,
    }, {
        // מיילים של משתמשים מנוהלים במסך "ניהול משתמשים" בלבד.
        // Pmail נשאר לתיעוד היסטורי ולכן מוצג כאן לקריאה בלבד.
        name: 'מייל מנהל (ישן)',
        selector: row => row.Pmail,
        cell: (row) => {
            const value = (row.Pmail ?? '').trim();
            return (
                <span
                    dir="ltr"
                    title='לעריכת מיילים יש לעבור למסך "ניהול משתמשים"'
                    style={{ color: '#888' }}
                >
                    {value || '—'}
                </span>
            );
        },
        sortable: true,
    },
];


function EditableCell({ value, rowId, field, onUpdate }) {
    const [editing, setEditing] = useState(false);
    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleDoubleClick = () => {
        setEditing(true);
    };

    const handleBlur = () => {
        setEditing(false);
        if (inputValue !== value && onUpdate) {
            onUpdate(inputValue);
        }
    };

    const trimmedValue = (value ?? '').trim();
    return editing ? (
        <input
            type="text"
            value={inputValue ?? ''}
            autoFocus
            onChange={e => setInputValue(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={e => {
                if (e.key === 'Enter') {
                    handleBlur();
                }
            }}
            style={{ width: '100%' }}
        />
    ) : (
        <span onDoubleClick={handleDoubleClick} style={{ cursor: 'pointer', color: !trimmedValue ? '#888' : undefined }}>
            {trimmedValue ? trimmedValue : '—'}
        </span>
    );
}

export default function Mosdot() {
    const [rows, setRows] = useState([]);
    const [display, setDisplay] = useState([]);

    useEffect(() => {
        axios.post("api/getMosdot")
            .then((res) => {
                // Add update handlers to each row
                const withHandlers = res.data.rows.map(row => ({
                    ...row,
                    onUpdateSemel: (newValue, r) => handleUpdateField('Semel', newValue, r),
                    onUpdatePrincipal: (newValue, r) => handleUpdateField('Principal', newValue, r),
                    onUpdatePtel: (newValue, r) => handleUpdateField('Ptel', newValue, r),
                }));
                setRows(withHandlers);
                setDisplay(withHandlers);
            }).catch((error) => {
                console.error('Error:', error);
            });
    }, []);

    const handleUpdateField = async (field, newValue, row) => {
        // Send update to backend
        const response = await fetch(`/api/update${field}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: row.id || row.Semel, [field]: newValue })
        });
        if (response.ok) {
            // Only update after backend response
            axios.post("api/getMosdot")
                .then((res) => {
                    const withHandlers = res.data.rows.map(row => ({
                        ...row,
                        onUpdatePrincipal: (newValue, r) => handleUpdateField('Principal', newValue, r),
                        onUpdatePtel: (newValue, r) => handleUpdateField('Ptel', newValue, r),
                    }));
                    setRows(withHandlers);
                    setDisplay(withHandlers);
                });
        }
    };

    return (
        <>
            <Container fluid className='text-center'>
                <h3 className='pt-2'>
                    מוסדות
                </h3>
                <hr />
                <DataTable
                    columns={columns}
                    data={display}
                    striped
                    pagination
                    fixedHeader
                    fixedHeaderScrollHeight="66vh"
                    subHeader
                    subHeaderComponent={
                        <Row>
                            <Form.Control type="text" placeholder="חיפוש" onChange={(e) => {
                                const val = e.target.value.trim();
                                setDisplay(rows.filter(i =>
                                    `${i.ty} ${i.MosName} ${i.Mtype} ${i.Gender} ${i.Semel} ${i.Principal} ${i.Ptel} ${i.Pmail}`.includes(val)
                                ));
                            }} />
                        </Row>
                    }
                />
            </Container>
        </>
    );
}